<template>
  <div class="content-container">
    <div class="sd-input">
      <input
        v-model="form.name"
        :placeholder="`* ${Locale.i18n.t('global.name')}`"
        required
        :class="[{ warn: errors.name && showErrors }]"
        :maxlength="MAX_GUEST_FIELDS_CHAR.name"
        @focus="errors.name = false"
      />
      <p v-if="errors.name" class="warn-note-wrapper">
        <span class="star">*</span>
        {{ Locale.i18n.t('page.guest.name.invalid') }}
      </p>
    </div>
    <div class="sd-input">
      <input
        v-model="form.phone"
        :placeholder="`${Locale.i18n.t('global.phone')}`"
        required
        :class="[{ warn: errors.phone && showErrors }]"
        :maxlength="MAX_GUEST_FIELDS_CHAR.phone"
        @focus="errors.phone = false"
      />
      <p v-if="errors.phone" class="warn-note-wrapper">
        <span class="star">*</span>
        {{ Locale.i18n.t('page.guest.phone.invalid') }}
      </p>
    </div>
    <div class="sd-input">
      <input
        v-model="form.email"
        :placeholder="`* ${Locale.i18n.t('global.email')}`"
        required
        :class="[{ warn: errors.email && showErrors }]"
        :maxlength="MAX_GUEST_FIELDS_CHAR.email"
        @focus="errors.email = false"
      />
      <p v-if="errors.email" class="warn-note-wrapper">
        <span class="star">*</span>
        {{ Locale.i18n.t('page.guest.email.invalid') }}
      </p>
    </div>
    <div v-if="showDescriptionBox" class="sd-input">
      <textarea
        v-model="form.description"
        :placeholder="`* ${descriptionPlaceholder}`"
        required
        :class="[{ warn: errors.description && showErrors }]"
        rows="5"
        :maxlength="MAX_GUEST_FIELDS_CHAR.description"
        @focus="errors.description = false"
      />
      <p class="textarea-char" :class="{ exceed: isDescriptionExceed }">
        {{ form.description.length }} /
        {{ MAX_GUEST_FIELDS_CHAR.description }}
      </p>
      <p v-if="errors.description && (showErrors || isDescriptionExceed)" class="warn-note-wrapper">
        <span class="star">*</span>
        {{
          isDescriptionExceed
            ? Locale.i18n.t('page.guest.description.exceed', {
                maxChar: MAX_GUEST_FIELDS_CHAR.description,
              })
            : Locale.i18n.t('page.guest.description.invalid')
        }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Model, Prop, PropSync, Vue } from 'vue-property-decorator';
import { MAX_GUEST_FIELDS_CHAR } from '@/common/config';
import * as Locale from '@/plugins/i18n';

export interface TicketForm {
  name: string;
  email: string;
  description: string;
  phone: string;
}

@Component({})
export default class GuestFormContent extends Vue {
  @Model('input') readonly form!: TicketForm;
  @Prop() readonly showDescriptionBox!: boolean;
  @Prop() readonly descriptionMessage!: string;

  @PropSync('errors', {
    default: () => ({
      name: false,
      email: false,
      description: false,
      phone: false,
    }),
  })
  readonly inputErrors!: {
    name: boolean;
    email: boolean;
    description: boolean;
    phone: boolean;
  };

  readonly Locale = Locale;

  loading = false;
  MAX_GUEST_FIELDS_CHAR = MAX_GUEST_FIELDS_CHAR;

  get isDescriptionExceed() {
    return this.form.description.length > MAX_GUEST_FIELDS_CHAR.description;
  }

  get descriptionPlaceholder() {
    return this.descriptionMessage || Locale.i18n.t('global.describe');
  }

  get buttons() {
    return [
      {
        name: Locale.i18n.t('page.guest.button.proceed'),
        id: '',
        isActive: true,
      },
    ];
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
